<template>
  <div class="pass-pay-page">
    <div class="pass-pay-head">
      <h1>DSA Pass payment</h1>
      <p v-if="loading">Preparing checkout…</p>
      <p v-else-if="error">{{ error }}</p>
    </div>
    <dsa-loading v-if="loading" text="Loading checkout…" />
    <div id="checkout" class="checkout-mount" />
  </div>
</template>

<script>
import { getDsaPassOrder } from '@/api/dsa'
import { getUserId } from '@/utils/store'
import {
  STRIPE_PUBLISHABLE_KEY,
  getDsaPassEmbedPayUrl,
  getDsaPassPaymentReturnUrl,
  ensureStripeJs,
} from '@/utils/payment'

export default {
  name: 'StudentPassPay',
  data() {
    return {
      order_id: this.$route.query.order_id,
      loading: true,
      error: '',
    }
  },
  mounted() {
    this.boot()
  },
  methods: {
    async boot() {
      if (!this.order_id) {
        this.error = 'Missing order id'
        this.loading = false
        return
      }
      if (!getUserId()) {
        this.error = 'Please sign in again to continue payment.'
        this.loading = false
        this.$router.replace('/login')
        return
      }
      this.requestOrder()
    },
    async requestOrder() {
      const student_id = getUserId()
      try {
        let res = await getDsaPassOrder(this.order_id, student_id)
        if (!res.data || res.data.code !== 0) {
          await new Promise(resolve => setTimeout(resolve, 500))
          res = await getDsaPassOrder(this.order_id, student_id)
        }
        if (!res.data || res.data.code !== 0) {
          this.error = (res.data && res.data.msg) || 'Could not load order'
          this.loading = false
          return
        }
        const order = res.data.data
        if (order.status === '已支付') {
          this.error = 'This order is already paid.'
          this.loading = false
          return
        }
        try {
          await ensureStripeJs()
        } catch (e) {
          this.error = 'Payment SDK failed to load. Please refresh the page.'
          this.loading = false
          return
        }
        this.handleOrderData(this.order_id)
      } catch (e) {
        this.error = 'Failed to load order'
        this.loading = false
      }
    },
    handleOrderData(order_id) {
      this.pay(order_id)
    },
    pay(order_id) {
      const stripe = window.Stripe(STRIPE_PUBLISHABLE_KEY)
      const return_url = getDsaPassPaymentReturnUrl()
      const self = this

      async function initialize() {
        const fetchClientSecret = async () => {
          const response = await fetch(getDsaPassEmbedPayUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              order_id,
              return_url,
            }),
          })
          const result = await response.json()
          if (!result.clientSecret) {
            throw new Error(result.msg || 'No client secret')
          }
          return result.clientSecret
        }

        try {
          const checkout = await stripe.initEmbeddedCheckout({ fetchClientSecret })
          self.loading = false
          checkout.mount('#checkout')
        } catch (e) {
          self.error = 'Could not start checkout. Please try again.'
          self.loading = false
        }
      }

      initialize()
    },
  },
}
</script>

<style scoped>
.pass-pay-page{
  min-height:100vh;
  background:#f4f6f9;
  padding:24px;
  box-sizing:border-box;
}
.pass-pay-head{
  max-width:720px;
  margin:0 auto 20px;
}
.pass-pay-head h1{font-size:22px;font-weight:700;color:#185FA5}
.pass-pay-head p{color:#4a5568;margin-top:8px;font-size:14px}
.checkout-mount{
  max-width:720px;
  margin:0 auto;
  min-height:400px;
}
</style>
